import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { isObject } from 'utils/functions/isObject';

/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(
  error: unknown,
): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}

/*********************************************************
 *                     OTHER HELPERS                     *
 ********************************************************/

//Tipo del possibile errore restituito dalla transfomErrorResponse
export type TServerErrorMessage = {
  errorMessage: string;
};

//Type predicate per verificare se l'errore è di tipo TServerErrorMessage
export const isTServerErrorMessage = (
  error: unknown,
): error is TServerErrorMessage => {
  return isObject(error) && 'errorMessage' in error;
};
